<div class="modal-header">
  <h2 class="modal-title font-weight-bold" id="displayName">
    {{ "PATIENT.INFO.TITLE" | translate }} {{ patient?.lname }}
    {{ patient?.fname }}
  </h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid my-container">
    <div class="row my-row">
      <div id="info" class="w-100">
        <app-error
          [error_message]="errorMessage"
          [error_type]="errorType"
        ></app-error>
      </div>
    </div>

    <div class="row row-cols-2 my-row">
      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.FNAME" | translate }}</h6>
      </div>
      <div id="lname" class="col-8 my-col">{{ patient?.lname }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.LNAME" | translate }}</h6>
      </div>
      <div id="fname" class="col-8 my-col">{{ patient?.fname }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.MAIL" | translate }}</h6>
      </div>
      <div id="email" class="col-8 my-col">{{ patient?.user?.email }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.PHONE" | translate }}</h6>
      </div>
      <div id="email" class="col-8 my-col">{{ patient?.phoneNumber }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.INS" | translate }}</h6>
      </div>
      <div id="ins" class="col-8 my-col">{{ patient?.ins }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.CITY" | translate }}</h6>
      </div>
      <div id="city" class="col-8 my-col">{{ patient?.city }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">{{ "FORM.BIRTHDATE" | translate }}</h6>
      </div>
      <div id="birthDate" class="col-8 my-col">{{ patient?.dateOfBirth }}</div>

      <div class="col-4 my-col">
        <h6 class="items-annuaires">
          {{ "PATIENT.INFO.CONSENT-DATE" | translate }}
        </h6>
      </div>
      <div id="consentDate" class="col-8 my-col">
        {{ patient?.consentDate }}
      </div>
    </div>

    <div *ngIf="!patient?.shared">
      <h4 class="items-annuaires">
        <strong>{{ "PATIENT.INFO.LAST-MESSAGES" | translate }}</strong>
      </h4>
    </div>
    <div id="lastMessages" *ngIf="patient">
      <div class="table-container mat-elevation-z8">
        <div class="example-table-container">
          <table
            mat-table
            id="lastMessages"
            class="exemple-table"
            [dataSource]="lastMessages"
            *ngIf="lastMessages"
          >
            <ng-container matColumnDef="recipient">
              <th mat-header-cell *matHeaderCellDef class="text-primary">
                {{ "MESSAGES.LIST.SIGNATORIES" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let message"
                class="truncate-cell pr-1"
                data-toggle="tootip"
                data-placement="top"
                title="{{ message.messages.recipient }}"
              >
                {{ message.messages.recipient }}
              </td>
            </ng-container>

            <ng-container matColumnDef="objet">
              <th mat-header-cell *matHeaderCellDef class="text-primary">
                {{ "MESSAGES.LIST.SUBJECT" | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let message"
                class="truncate-cell pr-1"
                data-toggle="tootip"
                data-placement="top"
                title="{{ message.messages.objet }}"
              >
                {{ message.messages.objet }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef class="text-primary">
                {{ "MESSAGES.LIST.DATE" | translate }}
              </th>
              <td mat-cell *matCellDef="let message">
                {{ message.messages.date_envoi }}
              </td>
            </ng-container>

            <ng-container matColumnDef="attachments">
              <th mat-header-cell *matHeaderCellDef class="text-primary">
                {{ "MESSAGES.LIST.ATTACHMENTS" | translate }}
              </th>
              <td mat-cell *matCellDef="let message">
                <i
                  class="bi bi-paperclip"
                  *ngIf="message.messages.attachmentSize > 0"
                ></i>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="text-primary">
                {{ "MESSAGES.LIST.ACTION" | translate }}
              </th>
              <td mat-cell *matCellDef="let message">
                <button
                  *ngIf="isWithinLastThreeMonths(message.messages.date_envoi)"
                  type="button"
                  (click)="replayMessage(message); $event.stopPropagation()"
                  class="btn btn btn-success"
                  data-toggle="tootip"
                  data-placement="top"
                  title="Renvoyer le message"
                >
                  <em class="bi bi-arrow-clockwise"></em>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="open(row); selection.toggle(row)"
              [ngClass]="{ alternate: row.state == 1 }"
            ></tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal- modal-directory justify-content-around mt-3"
    *ngIf="patient"
  >
    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        type="button"
        class="btn btn-danger"
        (click)="activeModal.close('')"
      >
        {{ "BUTTONS.CLOSE" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="writeMessage(patient); activeModal.close()"
        data-toggle="tootip"
        data-placement="top"
        title="{{ 'BUTTONS.SEND-PATIENT-MESSAGE' | translate }}"
      >
        <em class="bi bi-envelope"></em>
      </button>
      <button
        *ngIf="!patient.shared"
        type="button"
        class="btn btn-primary"
        (click)="updatePatientInfo(patient)"
        data-toggle="tootip"
        data-placement="top"
        title="{{ 'BUTTONS.UPDATE-PATIENT-INFOS' | translate }}"
      >
        <em class="bi bi-pencil"></em>
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="replayMessages(patient)"
        [disabled]="disableReplayAll"
        data-toggle="tootip"
        data-placement="top"
        title="{{ 'BUTTONS.SEND-NOT-EXPIRED-MESSAGE' | translate }}"
      >
        <em class="bi bi-arrow-clockwise"></em>
      </button>
      <button
        *ngIf="!patient.shared"
        type="button"
        class="btn btn-danger"
        (click)="removePatient(patient)"
        data-toggle="tootip"
        data-placement="top"
        title="{{ 'BUTTONS.REMOVE-DIRECTORY-PATIENT' | translate }}"
      >
        <em class="bi bi-person-dash"></em>
      </button>
    </div>
  </div>
</div>
